import { Component, OnInit, Input, forwardRef, OnChanges } from "@angular/core";
import {
  trigger,
  state,
  style,
  animate,
  transition
} from "@angular/animations";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { MapService } from "./map.service";
import { ILocation } from "./models/iLocation";
import { ICountry } from "./models/iCountry";


export const CUSTOM_ADDRESS_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AddressComponent),
  multi: true
};

@Component({
  selector: "fm-address",
  templateUrl: "./address.component.html",
  styleUrls: ["./address.component.scss"],
  animations: [
    trigger("toggleAddress", [
      state(
        "hide",
        style({
          transform: "translateY(20%)",
          display: "none",
          opacity: 0
        })
      ),
      state(
        "show",
        style({
          transform: "translateY(0%)",
          opacity: 1,
          display: "block"
        })
      ),
      transition("hide => show", animate("300ms")),
      transition("show => hide", animate("300ms"))
    ])
  ],
  providers: [CUSTOM_ADDRESS_VALUE_ACCESSOR]
})
export class AddressComponent
  implements OnInit, OnChanges, ControlValueAccessor {
  constructor(protected mapService: MapService) {}

  state: String = "hide";
  selectedLocation: ILocation;
  locationList: ILocation[] = [];
  ngInitUnsubscribe: Subject<void> = new Subject<void>();
  isNew = true;
  @Input()
  isEditable = true;
  @Input()
  editBtnClass = "far fa-edit";
  @Input() isAccountingDisabled = false;
  @Input() countryLookupList: ICountry[] = [];

  ngOnInit() {
    this.mapService.editBtnClass = this.editBtnClass;
  }

  ngOnChanges() {
    this.mapService.editBtnClass = this.editBtnClass;
  }

  addressSaveHandler(event) {
    if (!this.isNew) {
      this.value = this.value.filter(
        v => !this.checkIfSameAddress(v, this.selectedLocation)
      );
    }

    this.value = [...this.value, event]; // directly using push here will not fire the onChange event!
    this.mapService.addLocation(event);
  }

  getTitleList() {
    return this.value.map(v => v.Title);
  }

  toggleNew() {
    this.mapService.resetLocation();
    this.isNew = true;
    this.state = "show";
  }
  addressFormCloseHandler() {
    this.state = "hide";
    this.isNew = false;
    this.selectedLocation = null;
    this.mapService.resetLocation();
  }

  getIsNew() {
    return this.isNew;
  }

  editClickHandler(event) {
    this.selectedLocation = event;
    this.isNew = false;
    this.state = "show";
  }
  addressDeleteHandler(event) {
    this.selectedLocation = null;
    this.state = "hide";
    this.isNew = false;
    this.value = this.value.filter(v => !this.checkIfSameAddress(v, event));
    this.mapService.removeLocation(event);
  }

  getSelectedLocationTitle() {
    try {
      return this.selectedLocation.Title;
    } catch (error) {
      return " ";
    }
  }

  getStateBoolean() {
    return this.state === "show" ? true : false;
  }

  getLocationList() {
    return this.value.sort((a, b) => a.Title.localeCompare(b.Title.valueOf()));
  }

  checkIfSameAddress(addr1: ILocation, addr2: ILocation) {
    if (addr1.Title === addr2.Title) {
      return true;
    } else {
      return false;
    }
  }

  // Functions for ngModel
  set value(val: ILocation[]) {
    if (this.locationList !== val) {
      this.locationList = val;
      this.onChange(val);
    }
  }

  get value(): ILocation[] {
    return this.locationList;
  }

  onChange = _ => {};
  onTouched = () => {};

  registerOnChange(fn: (_: any) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  writeValue(val: ILocation[]): void {
    this.locationList = val;
    this.onChange(val);
  }

  setDisabledState?(isDisabled: boolean): void {}
}
